import store from "./../../../store";
import {onMeasureUnitChange} from "./sqftMeasureUnitsHelper";
import sqftConfig from "../components/canvas/store/sqftConfig";
import {setSqftMeasureUnit} from "../../../actions/sqftFunctions";

export const setMeasureUnit = (value) => {
  sqftConfig.measureUnit = value
  store.dispatch(setSqftMeasureUnit(value));
  onMeasureUnitChange();
}
